import React from 'react';
import B2BService from './B2BService';
import '../css/B2B.css'
function B2B(props) {
    const{title}= props
    return (
        <div className={`p-5 b2b-container ${title==="Enterprises"?"b2b-enterprises":"b2b-educational"} `} style={{overflow: 'hidden'}}>
            <h3 className="text-center  letter-dis-2">B2B services we provide for {title}</h3>
            <div className="row justify-content-evenly ">
                <div className="col-md-4 d-flex flex-column justify-content-evenly " >
                    <B2BService position="left"/>
                    <B2BService position="left"/>
                    <B2BService position="left"/>
                    <B2BService position="left"/>
                    <B2BService position="left"/>
                </div>
                <div className="col-md-3 d-flex flex-column justify-content-evenly">
                    <img src={require('../resource/demo.webp')} style={{width: '100%', height: '20% '}}  className="my-2 rounded"   alt="" />
                    <img src={require('../resource/demo.webp')} style={{width: '100%', height: '20% '}}  className="my-2 rounded"   alt="" />
                    <img src={require('../resource/demo.webp')} style={{width: '100%', height: '20% '}}  className="my-2 rounded"   alt="" />
                </div>
                <div className="col-md-4 d-flex flex-column justify-content-evenly" >
                    <B2BService position="right"/>
                    <B2BService position="right"/>
                    <B2BService position="right"/>
                    <B2BService position="right"/>
                    <B2BService position="right"/>
                    
                </div>
            </div>
        </div>
    )
}

export default B2B;
